import { SeriesData } from '@/components/Survey/Utilities/ChartUtilities'

const SingleSelectSeries: SeriesData[] = [
  { name: 'Once per week', y: 8 },
  { name: 'A few times per month', y: 28 },
  { name: 'Once per month', y: 13 },
  { name: 'A few times per year', y: 29 },
  { name: 'Every day', y: 3 },
  { name: 'A few times per week', y: 12 },
  { name: 'Never', y: 6 }
]
const SingleSelectQuestionOptions = [
  {
    id: 5046882,
    text: 'Once per week',
    order: 2,
    hash: '27b749b17e9dce038e22b1cb63840cfd',
    qualificationTags: ['1_rpu9g58v5yf'],
    shuffle: false,
    isTerminating: true,
    isCorrectOption: false,
    image: null,
    link: null,
    label: 'Once per week',
    configuration: { questionOptionId: 5046882, title: '__vue_devtool_undefined__' }
  },
  {
    id: 5046883,
    text: 'A few times per month',
    order: 3,
    hash: 'cbe7f29c92039afac61297cd797ba06c',
    qualificationTags: ['1_rpu9g58v5yf'],
    shuffle: false,
    isTerminating: true,
    isCorrectOption: false,
    image: null,
    link: null,
    label: 'A few times per month',
    configuration: { questionOptionId: 5046883, title: '__vue_devtool_undefined__' }
  },
  {
    id: 5046884,
    text: 'Once per month',
    order: 4,
    hash: '3c9fc524cf8fc33ab9bf7d0d21df5a4a',
    qualificationTags: ['1_rpu9g58v5yf'],
    shuffle: false,
    isTerminating: true,
    isCorrectOption: false,
    image: null,
    link: null,
    label: 'Once per month',
    configuration: { questionOptionId: 5046884, title: '__vue_devtool_undefined__' }
  },
  {
    id: 5046885,
    text: 'A few times per year',
    order: 5,
    hash: '752df0fc5bd782ae1f722c7ad67f0b70',
    qualificationTags: [],
    shuffle: false,
    isTerminating: true,
    isCorrectOption: false,
    image: null,
    link: null,
    label: 'A few times per year',
    configuration: { questionOptionId: 5046885, title: '__vue_devtool_undefined__' }
  },
  {
    id: 5046880,
    text: 'Every day',
    order: 0,
    hash: '48bf14c419a1d441412510faf39c326d',
    qualificationTags: ['1_rpu9g58v5yf'],
    shuffle: false,
    isTerminating: true,
    isCorrectOption: false,
    image: null,
    link: null,
    label: 'Every day',
    configuration: { questionOptionId: 5046880, title: '__vue_devtool_undefined__' }
  },
  {
    id: 5046881,
    text: 'A few times per week',
    order: 1,
    hash: 'aa6955aba52116cfc4cefa6ca46884ed',
    qualificationTags: ['1_rpu9g58v5yf'],
    shuffle: false,
    isTerminating: true,
    isCorrectOption: false,
    image: null,
    link: null,
    label: 'A few times per week',
    configuration: { questionOptionId: 5046881, title: '__vue_devtool_undefined__' }
  },
  {
    id: 5046886,
    text: 'Never',
    order: 6,
    hash: '6e7b34fa59e1bd229b207892956dc41c',
    qualificationTags: [],
    shuffle: false,
    isTerminating: true,
    isCorrectOption: false,
    image: null,
    link: null,
    label: 'Never',
    configuration: { questionOptionId: 5046886, title: '__vue_devtool_undefined__' }
  }]

export const SingleSelectData = {
  series: SingleSelectSeries,
  questionOptions: SingleSelectQuestionOptions
}

const generateMatrixTotals = (count: number, barCount: number) => {
  let totals = {}
  const categories = []
  for (let i = 0; i < barCount; i++) {
    categories.push((i + 1).toString())
  }
  for (let i = 0; i < count; i++) {
    totals = Object.assign(totals, generateCategory(i, barCount))
  }
  return {
    totals,
    categories
  }
}

const generateCategory = (index: number, barCount: number) => {
  const counts: Record<number | string, number> = {}
  for (let i = 0; i < barCount; i++) {
    counts[i + 1] = Math.ceil(i + 1 * 10 * Math.random())
  }
  counts.segmentCount = 120
  return {
    [index + 1]: counts
  }
}

export const generateMatrixData = (groupCount: number, barCount: number) => {
  const { totals, categories } = generateMatrixTotals(groupCount, barCount)
  return {
    totals: totals,
    scaleCategories: categories,
    displayCategories: categories
  }
}

export const generateNumberData = (barCount: number, sorted?: boolean) => {
  let categories = Array.from({ length: barCount }).map((val, idx) => idx.toString())
  const indexTotals = categories.reduce((acc: Record<number, number>, val) => {
    acc[parseInt(val)] = Math.floor(Math.random() * 100)
    return acc
  }, {})
  if (sorted) {
    categories = categories.sort((a, b) => {
      return indexTotals[parseInt(b)] - indexTotals[parseInt(a)]
    })
  }
  const responseLength = Object.values(indexTotals).reduce((acc: number, val) => {
    return acc + val
  }, 0)
  return {
    categories,
    indexTotals,
    responseLength
  }
}

export const generateMultiselectData = (groupCount: number, barCount: number) => {
  const segmentTotals = Array.from({ length: groupCount }).reduce((acc: Record<string, Record<string, number>>, segment, segmentIndex) => {
    let categorySegmentTotal = 0
    const segmentTitle = `segment${segmentIndex}`
    acc[segmentTitle] = Array.from({ length: barCount }).reduce((acc: Record<string, number>, category, categoryIndex) => {
      const categoryResponseCount = Math.floor(Math.random() * 10) + 2
      acc[`category${categoryIndex}`] = categoryResponseCount
      categorySegmentTotal += categoryResponseCount
      if (categoryIndex === (barCount - 1)) {
        acc.segmentCount = categorySegmentTotal
      }
      return acc
    }, {})
    return acc
  }, {})
  const sortedCategories = Array.from({ length: barCount }).map((category, index) => `category${index}`)
  // return {
  //   segmentTotals: { '18-24': { 'Cajun spices': 8, segmentCount: 28, Ranch: 12, 'Honey BBQ': 13, Honey: 7, Sriracha: 9 }, '25-34': { 'Honey BBQ': 15, segmentCount: 31, 'Cajun spices': 6, Honey: 15, Sriracha: 8, Other: 3, Ranch: 8 }, '35-44': { Ranch: 12, segmentCount: 27, 'Cajun spices': 8, 'Honey BBQ': 14, Honey: 12, Other: 4, Sriracha: 1 }, '45-54': { 'Cajun spices': 3, segmentCount: 24, 'Honey BBQ': 13, Honey: 13, Ranch: 9, Sriracha: 4, Other: 3 }, '55-64': { 'Honey BBQ': 4, segmentCount: 18, Honey: 11, Ranch: 9, Sriracha: 3, 'Cajun spices': 5, Other: 3 }, '65+': { Ranch: 11, segmentCount: 17, 'Cajun spices': 2, Sriracha: 3, 'Honey BBQ': 5, Honey: 9, Other: 3 } },
  //   sortedCategories: ['Honey', 'Honey BBQ', 'Ranch', 'Cajun spices', 'Sriracha', 'Other']
  // }
  return {
    segmentTotals,
    sortedCategories
  }
}
